// ReusableSnackbar.js
import React from "react";
import { Snackbar, Alert, Box } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

export default function ReusableSnackbar({
  open,
  message,
  type = "success",
  onClose,
}) {
  const isSuccess = type === "success";

  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      sx={{ mt: "35px" }}
    >
      <Alert
        severity={isSuccess ? "success" : "error"}
        icon={
          isSuccess && (
            <Box
              sx={{
                backgroundColor: "#F0F7FF",
                width: 24,
                height: 24,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
              }}
            >
              <CheckCircleOutlineIcon
                fontSize="small"
                sx={{ color: "#2B911C" }}
              />
            </Box>
          )
        }
        sx={{
          width: "100%",
          alignItems: "center",
          backgroundColor: isSuccess ? "#F0F7FF" : "#FFE5E5",
          color: isSuccess ? "#1A2025" : "#C00000",
          fontSize: { xs: "10px", md: "12px", lg: "18px" },
          fontWeight: 400,
          borderRadius: "12px",
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
